/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { EmployeeLoginDTO, HTTPValidationError } from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Auth<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Auth
   * @name EmloyeeLoginApiAuthEmployeeLoginPost
   * @summary Emloyee Login
   * @request POST:/api/auth/employee/login
   * @response `204` `void` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  emloyeeLoginApiAuthEmployeeLoginPost = (data: EmployeeLoginDTO, params: RequestParams = {}) =>
    this.request<void, HTTPValidationError>({
      path: `/api/auth/employee/login`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
}
